import React, {lazy, Suspense, useEffect} from "react";
import {isMobile} from "react-device-detect";
import {Box, Modal} from "@mui/material";
import {useSelector} from "react-redux";
import {IAppState} from "../../store/models";
import {ShelfPromoDetailsPopup} from "../shelfPromoDetailsPopup/shelfPromoDetailsPopup";
import {ShelvesScreenContent} from "./shelvesScreenContent";
import {makeStyles} from "@mui/styles";
import {resetMobileZoom} from "../../com/globalsFunctions/globalFunctions";

const Checkout = lazy(() => import("../checkout"));
const Basket = lazy(() => import("../basket"));
const ProductDetails = lazy(() => import("../details"));
const ShareMenu = lazy(() => import("../sharePopup/shareMenu"));
const AddToMyListOneItemPopupWrapper = lazy(() => import("../addToMyListOneItemPopup/addToMyListOneItemPopupWrapper"));

const useStyles = makeStyles(() => ({
    myListWrapper: (props: any) => ({
        position: `fixed`,
        right: props.direction === `rtl` ? `auto` : `0`,
        left: props.direction === `rtl` ? `0` : `auto`,
        top: `60px`,
        zIndex: 3,
        direction: props.direction,
    }),

}))


const ShelvesScreen = () => {
    const {shelvesScreen, controlsBranch, flyersBranch} = useSelector((state: IAppState) => state);
    const {showBasket, shareMenu, isPortraitView} = controlsBranch;
    const stylesProperties = {
        direction: flyersBranch.data?.dir.toLowerCase(),
    }
    const isMobileView = isPortraitView || isMobile;
    const isHebrewStyle = flyersBranch.data?.dir === "RTL";
    const classes = useStyles(stylesProperties);

    useEffect(() => {
        if(isMobileView){
            resetMobileZoom();
        }
        return () => {
            if(isMobileView){
                resetMobileZoom();
            }
        }
    }, [])

    if(isMobileView && shelvesScreen.isOpen){
        return (
            <ShelvesScreenContent/>
        )
    }

    return (
        <Modal open={shelvesScreen.isOpen}>
            <Box sx={{height: `${document.documentElement.clientHeight}px`}}>
                <ShelvesScreenContent/>
                <Suspense fallback={<></>}>
                    <ShelfPromoDetailsPopup/>
                </Suspense>
                <Suspense fallback={<></>}>
                    <AddToMyListOneItemPopupWrapper/>
                </Suspense>
                <Suspense fallback={<></>}>
                    <Checkout/>
                </Suspense>
                <Suspense fallback={<></>}>
                    {
                        showBasket &&
                        <Box className={classes.myListWrapper}>
                            <Basket/>
                        </Box>
                    }
                </Suspense>
                <Suspense fallback={<></>}>
                    {shareMenu.isOpen &&
                        <ShareMenu isHebrewStyle={isHebrewStyle}/>
                    }
                </Suspense>
                <Suspense fallback={<></>}>
                    <ProductDetails/>
                </Suspense>
            </Box>
        </Modal>
    )
}

export default ShelvesScreen;